import {
  PatientCentralRefDataConsumerRenderProps,
  withPatientCentralRefDataContext
} from 'components/patient-entry/PatientCentralRefDataContext';
import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Button, Icon } from 'semantic-ui-react';
import { SemanticCOLORS } from 'semantic-ui-react/dist/commonjs/generic';
import styled from 'styled-components';

const StyledHeaderSpan = styled.span`
  font-weight: bold;
  padding-left: 1rem;
  vertical-align: middle;
  font-size: 1.3rem !important;
`;

const ActionsToolbar = styled.div`
  padding: 0.5rem;
  padding-bottom: 2rem !important;
  padding-left: 0;
`;

interface Props extends PatientCentralRefDataConsumerRenderProps, MessageSourceProps {
  disabled?: boolean,
  className?: string,
  headerMessage: string
}

interface State {
}

class PatientCentralPageHeader extends Component<Props, State> {

  constructor(props: Props) {
    super(props);
  };

  render(): React.ReactNode {

    const {
      anonymousMode,
      setAnonymousMode,
      headerMessage,
      className,
      getMessage
    } = this.props;

    let anonymousModeIconColor: SemanticCOLORS = anonymousMode ? "green" : "red";

    return (
        <ActionsToolbar className={`page-header ${className}`}>
          <StyledHeaderSpan className="title">
            {headerMessage}
          </StyledHeaderSpan>
          <Button
              floated={'right'}
              compact
              labelPosition="left"
              icon
              onClick={setAnonymousMode}
          >
            <Icon name="circle" color={anonymousModeIconColor}/>
            {getMessage("patientCentral.anonymousMode")}
          </Button>
        </ActionsToolbar>
    )
  }

}

export default withMessages(withPatientCentralRefDataContext(PatientCentralPageHeader));
